import {
  ACTION_DETACH_TWITTER__REQUEST,
  ACTION_DETACH_TWITTER__SUCCESS,
  ACTION_DETACH_TWITTER__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DETACH_TWITTER__REQUEST:
    case ACTION_DETACH_TWITTER__SUCCESS:
      return null;

    case ACTION_DETACH_TWITTER__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
